export default {
	DELETED: 0,
	REGISTER_NOT_COMPLETED: 1,
	WEB_USER: 2,
	TRADE_LEAD: 3,
	QUALIFIED: 4
}
